import styled from "styled-components"

import { Typography } from "components/common/index"

const SectionTitle = styled(Typography).attrs(() => ({
  as: "h3",
}))`
  ${({ theme }) => `
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes[20]};
    font-weight: normal;
    letter-spacing: 0.5px;
    margin-bottom: ${theme.space[3]};
    margin-top: ${theme.space[1]};
  `}
`

export default SectionTitle
